import { Box, Stack, Typography } from '@mui/material';
import { BusinessRounded } from '@mui/icons-material';

export function MissingTenantView() {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
      }}
    >
      <Stack spacing={3} alignItems="center" sx={{ maxWidth: 400, textAlign: 'center' }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            bgcolor: 'rgba(99,102,241,0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <BusinessRounded sx={{ fontSize: 40, color: 'primary.main' }} />
        </Box>
        <Box>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Sin Organización Seleccionada
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Para ver la información de este módulo, primero debes seleccionar un seminario u
            organización en el menú lateral izquierdo.
          </Typography>
        </Box>
        <Typography variant="caption" color="text.disabled">
          Si no ves ninguna organización disponible, contacta con tu administrador.
        </Typography>
      </Stack>
    </Box>
  );
}
